import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconEye = (iconProps: ChkIconProps) => (
  <ChkSvgWrapper {...iconProps}>
    <path
      d="M21.1242 11.9691C21.3607 12.2886 21.3607 12.7114 21.1242 13.0309C19.9757 14.5823 16.3254 19 12 19C7.67459 19 4.02435 14.5823 2.87579 13.0309C2.63929 12.7114 2.63929 12.2886 2.87579 11.9691C4.02435 10.4177 7.67459 6 12 6C16.3254 6 19.9757 10.4177 21.1242 11.9691Z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <circle
      cx="12.002"
      cy="12.5"
      r="3.00977"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </ChkSvgWrapper>
);
